export default {
  labels: {
    radius: 'Radio',
  },
};
